import React, { useState, useEffect } from 'react';
import BlogEntriesList from '../components/BlogEntriesList';
import { BlogListProvider, type SimpleBlogItem } from '../utils/BlogListProvider';

function BlogList() {
    const [entries, setEntries] = useState<SimpleBlogItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        BlogListProvider.getInstance()
            .GetBloggerInformation()
            .then((data) => {
                if (!cancelled) setEntries(data.filter((e) => e.approved));
            })
            .catch((err) => {
                if (!cancelled) {
                    setError(err instanceof Error ? err.message : 'Failed to load blog list');
                    setEntries([]);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, []);

    if (loading) {
        return (
            <div className="blog-list-page">
                <div className="page-title">
                    <div className="container">
                        <h1>Blogs</h1>
                    </div>
                </div>
                <section className="section">
                    <div className="container">
                        <div className="text-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading…</span>
                            </div>
                            <p className="mt-2 text-muted">Blogs werden geladen…</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    if (error) {
        return (
            <div className="blog-list-page">
                <div className="page-title">
                    <div className="container">
                        <h1>Blogs</h1>
                    </div>
                </div>
                <section className="section">
                    <div className="container">
                        <div className="alert alert-danger">{error}</div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className="blog-list-page">
            <div className="page-title">
                <div className="container headline">
                    <h1>Blogs</h1>
                    <p>Do you want to see your blog listed here, too? Just fill out the form: <a href="https://forms.office.com/e/4ep84kzNue" target="_blank">add my Blog</a></p>
                </div>
            </div>
            <section className="section blog blog-list" id="blog-list">
                <div className="container">
                    {entries.length === 0 ? (
                        <p className="text-muted text-center py-5">Keine Blogs vorhanden.</p>
                    ) : (
                        <BlogEntriesList blogEntries={entries} />
                    )}
                </div>
            </section>
        </div>
    );
}

export default BlogList;
